<template>
  <div v-if="actions.length" class="row mb-3 g-3">
    <div v-for="action in actions" :key="action.route" class="col-6 col-md-4 col-lg-3">
      <router-link
        :to="action.route"
        class="card h-100 text-decoration-none dq-employee-quick-action"
      >
        <div class="card-body d-flex align-items-center gap-3 py-3">
          <span
            class="avatar avatar-md avatar-rounded bg-primary-transparent text-primary flex-shrink-0"
          >
            <i :class="action.icon"></i>
          </span>
          <div class="min-w-0">
            <h6 class="mb-0 text-gray-9 text-truncate">{{ action.label }}</h6>
            <p v-if="action.hint" class="text-muted small mb-0 text-truncate">
              {{ action.hint }}
            </p>
          </div>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useEmployeeDashboardAccess } from "@/composables/useEmployeeDashboardAccess";

const {
  showPayrollSelfService,
  showLeaveSelfService,
  showAttendanceDashboard,
  showTickets,
  showPolicies,
} = useEmployeeDashboardAccess();

const actions = computed(() => {
  const list = [
    {
      label: "Documents",
      hint: "Contract & uploads",
      route: "/dashboard/my-documents",
      icon: "ti ti-file-description",
      show: true,
    },
    {
      label: "My Payslips",
      hint: "Salary history",
      route: "/payroll/my-payslips",
      icon: "ti ti-receipt",
      show: showPayrollSelfService.value,
    },
    {
      label: "My P9",
      hint: "Tax certificate",
      route: "/payroll/my-p9",
      icon: "ti ti-file-certificate",
      show: showPayrollSelfService.value,
    },
    {
      label: "Leave",
      hint: "Apply & track",
      route: "/leave/leaves-employee",
      icon: "ti ti-beach",
      show: showLeaveSelfService.value,
    },
    {
      label: "Attendance",
      hint: "Clock in & history",
      route: "/attendance/attendance-employee",
      icon: "ti ti-clock",
      show: showAttendanceDashboard.value,
    },
    {
      label: "Tickets",
      hint: "Support requests",
      route: "/tickets/ticket",
      icon: "ti ti-ticket",
      show: showTickets.value,
    },
    {
      label: "Policies",
      hint: "Company rules",
      route: "/employee/policy",
      icon: "ti ti-book",
      show: showPolicies.value,
    },
    {
      label: "Notifications",
      hint: "Updates & alerts",
      route: "/notifications",
      icon: "ti ti-bell",
      show: true,
    },
  ];

  return list.filter((item) => item.show);
});
</script>

<style scoped>
.dq-employee-quick-action {
  transition: box-shadow 0.15s ease, transform 0.15s ease;
}

.dq-employee-quick-action:hover {
  box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.08);
  transform: translateY(-1px);
}
</style>
